<template>
  <section>
    <h3 class="summary-title">Summary</h3>
    <p class="summary-text">
      Engineering Manager with 10+ years leading customer-facing product delivery in FinTech, Logistics, and Energy.
      Currently Head of Customer-Facing Delivery, leading 11 engineers across lending and BNPL products. I act as a
      trusted bridge between business and engineering — translating strategic goals into scalable architectures and
      predictable, high-quality releases, with recent cross-functional initiatives growing daily loan volume 4× (~100
      to 460+).
      <br />
      <br />
      Strong technical foundation in solution architecture (React/TypeScript) and full-stack decision-making, focused
      on enabling teams to deliver. I partner with Product, Design, Business, and Risk stakeholders to align roadmaps
      and measure outcomes. Early adopter of AI-augmented engineering — integrating Codex, Holmes, and OpenSpec into
      team workflows to accelerate delivery and code quality.
    </p>
    <p class="summary-text">
      <b class="accent-me">Open to Engineering Manager, Tech Lead Manager, and Head of Delivery roles in Europe or the
        Americas (remote or hybrid). Let's connect if you need someone who leads engineering teams, bridges business and
        tech, and ships customer-facing fintech products at scale. 🚀</b>
    </p>
  </section>
</template>

<script>
export default {
  name: "ResumeSummary"
};
</script>

<style lang="scss">
section {
  padding-top: 40px;
  line-height: 40px;
  padding-inline: 7vw;
}

.summary-title {
  font-size: 1.55rem;
  color: #23415d;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid #23415d;
}

.summary-text {
  padding: 20px;
  line-height: 20px;
  text-align: left;
}

.accent-me {
  font-weight: 900;
  color: #23415d;
}
</style>